import React, { useState } from "react";

//@Components
import AssetVersionEditVersionModal from "../AssetsVersionsPageModal/AssetVersionEditVersionModal";

//@MUI
import { TableRow, TableCell, Modal, Button } from "@material-ui/core";
import NoThumbnail from "../../Utilities/NoThumbnail.component";
import ImageViewer from "../../Utilities/ImageViewer/ImageViewer.component";
import useStyles from "./Assetversionlist.style";
import StatusDropDown from "../../Utilities/StatusDropDown/StatusDropDown.component";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import { fdelete } from "../../../API/callsAPI";
import DateAndTimeViewer from "../../Utilities/DateAndTimeViewer/DateAndTimeViewer.component";
import TaskDetailsOnHover from "../../Utilities/TaskDetailsOnHover/TaskDetailsOnHover";
import { ChatText } from "phosphor-react";
import { useRef } from "react";
import { Tooltip, Typography, Chip } from "@mui/material";
import { Edit3 } from "react-feather";

export default function Assetversionslist(props) {
  const classes = useStyles();

  const [isEditAssetVerisonModalOpen, setEditAssetVersionModalOpen] =
    useState(false);

  const [isDeleteAssetVerisonModalOpen, setDeleteAssetVersionModalOpen] =
    useState(false);
  const [deleteData, setDeleteData] = useState({});

  function handleEditAssetVersionModalState(e) {
    e?.stopPropagation();
    setEditAssetVersionModalOpen(!isEditAssetVerisonModalOpen);
  }

  function handleDeleteAssetVersionModalState(e, data) {
    e?.stopPropagation();
    setDeleteData(data);
    setDeleteAssetVersionModalOpen(!isDeleteAssetVerisonModalOpen);
  }

  const handleAssetVersionDelete = async () => {
    try {
      await fdelete({
        url: `trackables/asset-version/${deleteData?.id}/`,
      });
      props.updateRefreshCounter();
      setDeleteAssetVersionModalOpen(false);
      setEditAssetVersionModalOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <TableRow
        hover
        onClick={(e) => props.openAssetDetailModal(props.data)}
        style={{
          cursor: "pointer",
          width: "100%",
          display: "table",
          tableLayout: "fixed",
        }}
      >
        <TableCell
          align="left"
          className={classes.assetVersionListPageTableCellThree}
        >
          <div style={{ display: "flex" }}>
            {props.data.thumbnail ? (
              <ImageViewer
                url={props.data.thumbnail}
                sliderState={props.isAssetTogglerOn ? 25 : 0}
              />
            ) : (
              <NoThumbnail sliderState={props.isAssetTogglerOn ? 25 : 0} />
            )}
            <p style={{ marginLeft: "10px" }}>
              {props.data.name ? props.data.name : "No Name"}
            </p>
          </div>
        </TableCell>

        <TableCell
          align="center"
          className={classes.assetVersionListPageTableCell}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DateAndTimeViewer dateAndTime={props.data.updated_at} />
          </div>
        </TableCell>
        <TableCell className={classes.assetVersionListPageTableCell}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "15px",
            }}
          >
            <StatusDropDown
              url={`trackables/asset-version/${props.data.id}/`}
              statusList={props.status}
              currStatus={props.data.status}
              updateRefreshCounter={props.updateRefreshCounter}
            />
          </div>
        </TableCell>
        <TableCell
          align="center"
          className={classes.assetVersionListPageTableCell}
        >
          <span>
            {props.data.created_by
              ? props.data.created_by.first_name +
                " " +
                props.data.created_by.last_name
              : " "}
          </span>
        </TableCell>
        <TableCell
          align="center"
          className={classes.assetVersionListPageTableCell}
        >
          {props.data && props.data.task && props.data.task.id ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Tooltip
                describeChild
                arrow
                placement="right"
                title={<TaskDetailsOnHover task={props.data.task} />}
                slotProps={{
                  popper: {
                    sx: {
                      "& .MuiTooltip-tooltip": {
                        padding: "0px",
                        backgroundColor: "transparent",
                        border: "none",
                      },
                      "& .MuiTooltip-arrow": {
                        color: "#6C65D9",
                      },
                    },
                  },
                }}
              >
                <Chip
                  sx={{
                    width: "max-content",
                    cursor: "pointer",
                    fontSize: {
                      xs: "8px !important",
                      sm: "10px !important",
                      md: "10px !important",
                      lg: "12px !important",
                      xl: "14px !important",
                    },
                    color: "#f9f9f9 !important",
                    padding: "5px 6px !important",
                  }}
                  size="small"
                  label={props.data.task.name ?? ""}
                  variant="outlined"
                />
              </Tooltip>
            </div>
          ) : (
            <Typography
              sx={{
                fontSize: {
                  xs: "8px !important",
                  sm: "10px !important",
                  md: "10px !important",
                  lg: "12px !important",
                  xl: "14px !important",
                },
              }}
            >
              No Related Task
            </Typography>
          )}
        </TableCell>
        <TableCell
          align="center"
          className={classes.assetVersionListPageTableCellTwo}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ChatText
              size={17}
              color="#606479"
              weight="fill"
              style={{ marginRight: "7px" }}
            />
            {props.data.related_comments_number}
          </div>
        </TableCell>
        <TableCell
          align="right"
          className={classes.assetVersionListPageTableCellTwo}
        >
          <Tooltip title="Edit Asset" placement="top">
            <Button
              id="editAssetVersion"
              className={classes.inlineButtons}
              onClick={(e) => handleEditAssetVersionModalState(e)}
            >
              <Edit3 style={{ padding: "2px" }} />
            </Button>
          </Tooltip>
        </TableCell>
        <div>
          <Modal
            className={classes.assetsVersionModals}
            open={isEditAssetVerisonModalOpen}
            onClose={(e) => {
              setEditAssetVersionModalOpen(false);
              e.stopPropagation();
            }}
          >
            <AssetVersionEditVersionModal
              taskList={props.taskList}
              fetchTasks={props.fetchTasks}
              openCreateNewStatusModal={props.openCreateNewStatusModal}
              status={props.status}
              data={props.data}
              projectId={props.projectId}
              handleEditAssetVersionModalState={
                handleEditAssetVersionModalState
              }
              handleDeleteAssetVersionModalState={
                handleDeleteAssetVersionModalState
              }
              updateRefreshCounter={props.updateRefreshCounter}
              dragScreen={props.dragScreen}
              handleDragScreen={props.handleDragScreen}
              setDragFileEnterModal={props.setDragFileEnterModal}
              customFields={props.customFields}
            />
          </Modal>
        </div>
        <div>
          <Modal
            className={classes.assetsVersionModals}
            open={isDeleteAssetVerisonModalOpen}
            onClose={(e) => {
              setDeleteAssetVersionModalOpen(false);
              e.stopPropagation();
            }}
          >
            <DeleteModal
              type="assets version"
              name={deleteData?.name}
              handleCloseDeleteModal={() => {
                setDeleteAssetVersionModalOpen(false);
              }}
              handleDelete={handleAssetVersionDelete}
            />
          </Modal>
        </div>
      </TableRow>
    </>
  );
}
